/**
 * policyBuilderState.js — Pure functions for the budget-policy escalation-step builder.
 * No React dependencies. Handles defaults, serialization, and parsing.
 */

let _seq = 0;
const clientId = () => `step-${++_seq}-${Math.floor(Math.random() * 1e6)}`;

export function createDefaultStep() {
  return {
    id: clientId(),
    trigger_level: "soft",
    action: "notify",
    delivery_channels: ["email"],
    delivery_recipients: [{ type: "role", role: "finance_owner" }],
    delivery_enabled: true,
    approval_role: null,
  };
}

export function createDefaultPolicy() {
  return {
    name: "",
    description: "",
    applies_to: "general",
    is_default: false,
    soft_pct: 90,
    hard_pct: 100,
    breach_eta_days: 7,
    anomaly_enabled: true,
    spike_multiplier: null,
    spike_baseline_days: null,
    steps: [],
  };
}

export function serializePolicy(p) {
  return {
    name: p.name,
    description: p.description,
    applies_to: p.applies_to,
    is_default: !!p.is_default,
    soft_pct: Number(p.soft_pct),
    hard_pct: Number(p.hard_pct),
    breach_eta_days: Number(p.breach_eta_days),
    anomaly_enabled: !!p.anomaly_enabled,
    spike_multiplier: p.spike_multiplier == null ? null : Number(p.spike_multiplier),
    spike_baseline_days:
      p.spike_baseline_days == null ? null : Number(p.spike_baseline_days),
    steps: (p.steps || []).map((s, i) => ({
      step_order: i + 1,
      trigger_level: s.trigger_level,
      action: s.action,
      delivery_channels: s.delivery_channels,
      delivery_recipients: s.delivery_recipients,
      delivery_enabled: s.delivery_enabled,
      approval_role: s.approval_role,
    })),
  };
}

export function parsePolicy(api) {
  return {
    ...createDefaultPolicy(),
    ...api,
    steps: (api.steps || []).map((s) => ({
      ...createDefaultStep(),
      ...s,
      id: clientId(),
    })),
  };
}
